import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';

import AccountNumberAutoSuggests from '../common/accountNumberAutoSuggests';

/* Actions */
import {
	getOrderDetailsList,
	saveLookSerialNoData,
	getOrderList,
	getOrderDetails,
	saveOrderShippingDetails
} from '../../../redux/actions';

class LookUpSerialNo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            productListResponse: null,
			productSerialSearchResponse: null,
			orderNumberSearchForm: {
				params: {
					orderNumber: '',
				},
				errors: {
					orderNumberError: '',
				}
			},
			productSerialSearchForm: {
				params: {
					productNumber: '',
					serialNumber: '',
				},
				errors: {
					productNumberError: '',
					serialNumberError: '',
					serialNumberErrorMessage: ''
				}
			},
            resultOrderNumber: '',
			showOrderNumberSearchResult: false,
			showProductSerialNumberSearchResult: false,
        }
    }
	componentWillMount() {
		window.scrollTo(0, 0);
		const self = this;
		let { lookUpSerialNoData } = self.props.state.order;
		if(lookUpSerialNoData) {
			lookUpSerialNoData = JSON.parse(JSON.stringify(lookUpSerialNoData));
			self.setState({
				productListResponse: lookUpSerialNoData,
				resultOrderNumber: lookUpSerialNoData.orderNumber,
				showOrderNumberSearchResult: true,
			});
			this.props.saveLookSerialNoData(null);
		}
	}
	componentWillUnMount() {
		this.props.saveLookSerialNoData(null);
	}

	handleFetchOrderDetails(orderDetails, wheretoRedirect, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			getOrderDetailsCallCompleted: false,
			getOrderShippingDetailsCallCompleted: false,
		}, () => {
			self.props.getOrderDetails('orderNumber='+orderDetails.order_NUMBER+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
				if(!response.status || !response.responseObject) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					self.setState({
						getOrderDetailsCallCompleted: true
					}, () => {
						self.callbackAfterServiceCall(wheretoRedirect);
					});
				}
			});
			self.props.saveOrderShippingDetails(null);
			self.props.getOrderShippingDetails(orderDetails.order_NUMBER, response => {
				if(!response.status || !response.responseObject) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					self.setState({
						getOrderShippingDetailsCallCompleted: true,
						getOrderShippingDetailsData: response,
					}, () => {
						self.callbackAfterServiceCall(wheretoRedirect);
					});
				}
			});
		});
	}
	callbackAfterServiceCall(wheretoRedirect) {
		const self = this;
		const { getOrderDetailsCallCompleted, getOrderShippingDetailsCallCompleted, getOrderShippingDetailsData } = self.state;
		if(getOrderDetailsCallCompleted && getOrderShippingDetailsCallCompleted) {
			self.props.saveOrderShippingDetails(getOrderShippingDetailsData);
			browserHistory.push('/' + wheretoRedirect);
		}
	}
	updateParams(formName, event) {
		//Reseting Errors on change
		const self = this;
		let {name: fieldName, value: fieldValue} = event.target;
		let fieldError = '';

		if (fieldName === 'orderNumber') {
			fieldValue = fieldValue.trim();
			if (fieldValue.length > 10 || /\D/.test(fieldValue)) {
				fieldError = 'error';
			}
		}

		self.setState({
			[formName]: {
				...self.state[formName],
				params: {
					...self.state[formName].params,
					[fieldName]: fieldValue
				},
				errors: {
					...self.state[formName].errors,
					[fieldName+'Error']: fieldError
				},
			}
		});
	}

    // on click event  get data
    handleSearchResult(event) {
        event.preventDefault();
        const self = this,
			params = self.state.orderNumberSearchForm.params,
			errors = self.state.orderNumberSearchForm.errors;
		let formError = false;

		if(errors.orderNumberError || !/^\d{10}$/.test(params.orderNumber)) {
			errors.orderNumberError = 'error';
			formError = true;
		}

		// set state null before call
        self.setState({
            errorMessage: '',
            productListResponse: null,
            orderNumberError: '',
			orderNumberSearchForm: {
				...self.state.orderNumberSearchForm,
				errors
			},
			showOrderNumberSearchResult: false,
			showProductSerialNumberSearchResult: false,
        }, () => {
			//check ordernumber is null or not
			if(!formError) {
				self.props.fireGTMTag('Lookup Serial Number Search', {
					searchTerm: params.orderNumber,
					searchType: 'serial number'
				});
				const orderNumber = params.orderNumber;
	             // call api
	            self.props.getOrderDetailsList('orderNumber='+orderNumber +'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
	                let errorMessage = '';
					let data = null;
	                // error msg according to order status is closed or not or also check response null
	                if(response.responseObject && (response.responseObject.orderStatus === 'CLOSED' || response.responseObject.orderStatus === 'BOOKED')) {
	                    // filter data which status is not cancelled
	                    response.responseObject.items = _.filter(response.responseObject.items, itm => {
	                        return itm.lineStatus !== 'CANCELLED' && itm.serialNumber
	                    });
						data = (response.responseObject && response.responseObject.items.length > 0 && (response.responseObject.orderStatus === 'CLOSED' || response.responseObject.orderStatus === 'BOOKED')) ? response.responseObject : null;
						errorMessage = data ? '' : 'No serials found for the given order.'
	                } else {
	                    errorMessage = "No serials found for the given order.";
	                }
	                // set in to state
	                self.setState({
						showOrderNumberSearchResult: true,
	                    resultOrderNumber: orderNumber,
						productListResponse: data,
	                    errorMessage,
	                    orderNumberError: errorMessage !== '' ? 'error' : ''
	                });
	            });
	        }
		});
    }

	handleProductSerialSearchResult(event) {
		event.preventDefault();
        const self = this,
			params = self.state.productSerialSearchForm.params,
			errors = self.state.productSerialSearchForm.errors;
		let formError = false;
		
		//Reset all errors
		let serialNumberError = "serialNumberError";
		let serialNumber = "serialNumber";
		if(!params[serialNumber]) {
			errors[serialNumberError] = 'error';
			formError = true;
		} else {
			errors[serialNumberError] = '';
			params[serialNumber] = (params[serialNumber]).toUpperCase()
		}

		if (/^[A-Za-z]{2}\d{6}$/.test(params[serialNumber])) {
			errors['serialNumberErrorMessage'] = ''
		}
		else{
			errors[serialNumberError] = 'error';
			errors['serialNumberErrorMessage'] = 'Serial numbers should have 2 letters and 6 numbers.'
			formError = true;
		}
			
		// set state null before call
        self.setState({
            errorMessage: '',
            productSerialSearchResponse: null,
			productSerialSearchForm: {
				...self.state.productSerialSearchForm,
				errors
			},
			showOrderNumberSearchResult: false,
			showProductSerialNumberSearchResult: false,
        }, () => {
			const { serialNumber, productNumber } = self.state.productSerialSearchForm.params;
			self.props.fireGTMTag('Lookup Serial Number Search', {
				searchTerm: `modelNumber=${productNumber}&serialNumber=${serialNumber}`,
				searchType: 'serial number'
			});
			if(!formError) {
				let queryString = `serialNumber=${serialNumber}`;
				if(productNumber){
					queryString=`${queryString}&modelNumber=${productNumber}`;
				}
				if(self.props.state.user.userDetails.typeOfUser == "customer"){
					queryString=`${queryString}&accountNumber=${self.props.getSelectedAccountNumber()}`;
				}

				self.getOrderList(queryString);
			}
		});
	}

	getOrderList(queryString) {
		const self = this;
		
		self.props.getOrderList(queryString, (response) => {
			if(!response.status) {
				self.setState({
					errorMessage: response.responseMessage
				})
			} else {
				//response.responseObject = response.responseObject ? JSON.parse(response.responseObject) : [];
				if(response.responseObject.length) {
					if(self.props.state.user.userDetails.typeOfUser !== 'employee') {
						response.responseObject = response.responseObject.filter(item => item.account_NUMBER === self.props.getSelectedAccountNumber());
					}
					
					self.setState({
						showProductSerialNumberSearchResult: true,
						productSerialSearchResponse: response.responseObject,
						errorMessage: response.responseObject.length === 0 ? 'Order not found.' : ''
					});
				} 

				if(!response.responseObject || response.responseObject.length == 0 ) {
					self.setState({
						...this.state ,
						showProductSerialNumberSearchResult: true,
						errorMessage : ("Timeout exceeded" == response.responseMessage) ? "The search could not complete.  Please check the model & serial and try again." : 'No orders found.' ,
						productSerialSearchResponse : []
					})
				}
			}
		});
	}

	handleProductNumberChange(itemIndex, productDetails) {
		const self = this;
		if(productDetails && productDetails.status) {
			self.setState({
				productSerialSearchForm: {
					...self.state.productSerialSearchForm,
					params: {
						...self.state.productSerialSearchForm.params,
						productNumber: productDetails.sku
					}
				},
				inValid: false,
			});
		}
	}

	handleChangeProductNumberTextBox(indx, productNumber, productListSuggestion, inValid) {
		const self = this;
		self.setState({
			inValid,
			productSerialSearchForm: {
				params: {
					...self.state.productSerialSearchForm.params,
					productNumber,
				},
				errors: {
					...self.state.productSerialSearchForm.errors,
					productNumberError: '',
				}
			},
		});
	}

    render() {
		const self = this;
        return (
            <div>
                <h1 className="pageTitle" style={{margin: '21px 0'}}>Look Up Serial Numbers</h1>
                <table cellPadding={0} cellSpacing={15}>
                    <tbody>
                        {<tr>
                            <td><b>CSO (Order number):</b></td>
                            <td>
								<input style={{width: '100%'}} type="text" onKeyPress={this.props.acceptNumbersOnly} name="orderNumber" className={this.state.orderNumberSearchForm.errors.orderNumberError} value={this.state.orderNumberSearchForm.params.orderNumber} onChange={this.updateParams.bind(this, 'orderNumberSearchForm')} defaultValue={this.state.resultOrderNumber} />
								{this.state.orderNumberSearchForm.errors.orderNumberError && <span className="block red" style={{ position: 'absolute' }}>CSO must be a 10-digit numeric value</span>}
							</td>
							<td style={{padding:"1rem"}}><input onClick={this.handleSearchResult.bind(this)} type="submit" className="blueButton" style={{padding: '0.25em 1.75em'}} value="SEARCH" /></td>
							<td colSpan={3} />
						</tr>}
						<tr>
							<td className="textCenter" colSpan={3} style={{ paddingTop: '1rem'}}>
								<strong style={{color: '#092C74'}}>OR</strong>
							</td>
							<td colSpan={3} />
						</tr>
						<tr>
							<td><b>Product # (Optional):</b></td>
							<td className={this.state.productSerialSearchForm.errors.productNumberError + ' auto-width-input'}>
								<AccountNumberAutoSuggests onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)} updateQuickOrderState={this.handleProductNumberChange.bind(this)} size={8} />
								{(self.state.inValid)
									?<span className="red">Invalid product Number.</span>
									:null
								}
							</td>
							<td className="textCenter" style={{color: '#092C74'}}><strong>and</strong></td>
							<td><b>Serial #:</b></td>
							<td><input type="text" name="serialNumber" className={this.state.productSerialSearchForm.errors.serialNumberError} onChange={this.updateParams.bind(this, 'productSerialSearchForm')} maxLength={8}/></td>
							<td style={{padding:"1rem"}}><input onClick={this.handleProductSerialSearchResult.bind(this)} type="submit" value="Search" className="blueButton" style={{padding: '0.25em 1.75em'}} />
							</td>
							
						</tr>
						<tr style={{ position: 'relative' }}>
							{this.state.productSerialSearchForm.errors.serialNumberErrorMessage && 
								<div style={{ color: 'red', position: 'absolute', right: 0 }}>
								{this.state.productSerialSearchForm.errors.serialNumberErrorMessage}
								</div>
							}
						</tr>
                    </tbody>
                </table>
				{this.state.showOrderNumberSearchResult && (this.state.productListResponse  || this.state.errorMessage) &&
	                <div className="searchResults">
	                    {this.state.productListResponse !== null
	                        ?<table className="dataTable" width="100%">
	                            <caption>
	                                <b>CSO (Order number): {this.state.resultOrderNumber}</b>
	                            </caption>
	                            <thead>
	                                <tr>
										<th>Product</th>
	                                    <th>Product Description</th>
	                                    <th>Serial #</th>
	                                    <th>Ship Date</th>
	                                </tr>
	                            </thead>
	                            <tbody>
	                                {this.state.productListResponse && this.state.productListResponse.items.length > 0 && this.state.productListResponse.items.map((item, index) => {
										if(self.props.getItemTypeByName(item.item) === 'S' || (item.lineStatus && item.lineStatus.toLowerCase() === 'cancelled')) return null;
										let serialNumber = item.serialNumber;
										let shipDate = self.props.formatDate(item.shipDate,'MM/DD/YY');
										if (self.state.productListResponse.orderType && self.state.productListResponse.orderType.toLowerCase() === 'return order') {
											serialNumber = item.userItemDescription;
											shipDate = self.props.formatDate(item.actualFulfillmentDate,'MM/DD/YY');
										}
	                                    return <tr key={index}>
											<td>{item.item}</td>
	                                        <td>{item.itemDescription}</td>
	                                        <td>{serialNumber}</td>
											<td>{shipDate}</td>
	                                    </tr>
	                                })}
	                            </tbody>
	                        </table>
	                        :<p className="error">{this.state.errorMessage}</p>
	                    }
	                    <div className="clear" />
	                </div>
				}
				{this.state.showProductSerialNumberSearchResult && (this.state.productSerialSearchResponse || this.state.errorMessage) &&
	                <div className="searchResults">
	                    {this.state.productSerialSearchResponse.length > 0
	                        ?<table className="dataTable" width="100%">
	                            <thead>
	                                <tr>
										<th>Product</th>
										<th>Serial #</th>
										<th>CSO (Order number)</th>
										<th>Line type</th>
										<th>Ship Date</th>
										<th>Invoice #</th>
										<th>Inv Date</th>
										<th>Account #</th>
										<th>Account Description</th>
	                                </tr>
	                            </thead>
	                            <tbody>
	                                {this.state.productSerialSearchResponse && this.state.productSerialSearchResponse.length > 0 && this.state.productSerialSearchResponse.map((item, index) => {
										let shipDate = '', lineType='', invoiceDate = item.invoice_DATE ? self.props.formatDate(item.invoice_DATE) : '', accountName = item.account_NAME ? item.account_NAME.substring(0,25): "";
										shipDate = self.props.formatDate(item.actual_SHIPMENT_DATE,'MM/DD/YY');
										if(item.line_TYPE.toLowerCase() === "standard line") {
											lineType = 'Standard';
										} else if(item.line_TYPE.toLowerCase() === "return line") {
											lineType = 'Return';
										}
										if(item.line_TYPE.toLowerCase() == "internal order - line"){
											return "";
										}
	                                    return <tr key={index}>
											<td>{item.attribute1}</td>
											<td style={{width:100}}>{item.fm_SERIAL_NUMBER}</td>
	                                        <td>
												{item.account_NUMBER === this.props.state.user.selectedAccount.ACCOUNTNUMBER ?<a className="bold" href="" onClick={this.handleFetchOrderDetails.bind(this, item, 'orderdetails')}>
													{item.order_NUMBER}
												</a>: item.order_NUMBER
												}												
											</td>
											<td>{lineType}</td>
	                                        <td>{shipDate}</td>
											<td>{item.invoice_NUMBER}</td>
											<td>{invoiceDate}</td>
											<td>{item.account_NUMBER}</td>
											<td>{accountName}</td>
	                                    </tr>
	                                })}
	                            </tbody>
	                        </table>
	                        :<p className="error" style={{textAlign: 'center'}}>{this.state.errorMessage}</p>
	                    }
	                    <div className="clear" />
	                </div>
				}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
    getOrderDetailsList: (queryStringParams, callback) => dispatch(getOrderDetailsList(queryStringParams, callback)),
	getOrderList: (queryStringParams, callback) => dispatch(getOrderList(queryStringParams, callback)),
	getOrderDetails: (payload, callback) => dispatch(getOrderDetails(payload, callback)),
	saveLookSerialNoData: (data) => dispatch(saveLookSerialNoData(data)),
	saveOrderShippingDetails: (data) => dispatch(saveOrderShippingDetails(data))
});

LookUpSerialNo = connect(mapStateToProps, mapDispatchToProps)(LookUpSerialNo);
export default LookUpSerialNo;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/LookUpSerialNo/index.js